// Review state of a New Product Approval, shared by ProductApprovalsView and
// NewProductApprovalModal.

// Purchase manager's call: 'approved' | 'rejected' | null (not reviewed).
// Older records have no pmDecision, so fall back to the review fields.
export const pmDecisionOf = (approval) => {
    if (!approval) return null;
    if (approval.pmDecision) return approval.pmDecision;
    if (approval.rejectedStage === 'purchase_manager') return 'rejected';
    return approval.pmReviewedAt ? 'approved' : null;
};

export const isRejectedByPm = (approval) =>
    approval?.status === 'rejected' && approval?.rejectedStage === 'purchase_manager';

// The admin can act on anything still pending, and can still approve a
// product the purchase manager rejected (admin has the final say).
export const isAdminActionable = (approval) =>
    approval?.status === 'pending_pm' || approval?.status === 'pending_admin' || isRejectedByPm(approval);

// Waiting for a review: by the purchase manager (pending_pm) or the admin
// (pending_admin). The admin's "Pending" covers both.
export const isPendingApproval = (approval) =>
    approval?.status === 'pending_pm' || approval?.status === 'pending_admin';

export const isPendingPmApproval = (approval) => approval?.status === 'pending_pm';

// What waits for this viewer of Purchase Approvals ('pm' or 'admin') - its
// "Pending" tab and the red count on the Purchase Approvals buttons.
export const isWaitingForViewer = (approval, viewer) =>
    viewer === 'pm' ? isPendingPmApproval(approval) : isPendingApproval(approval);
